import { inject, Injectable } from '@angular/core';
import { AuthToken } from '@libs/shared/models';
import { map, Observable } from 'rxjs';
import { UserAuthHandler } from '../../auth.model';
import { LoginService } from '../../login';

@Injectable({
  providedIn: 'root',
})
export class LoginUserAuthHandler extends UserAuthHandler {
  private readonly loginService: LoginService = inject(LoginService);

  public override login(): Observable<AuthToken | undefined> {
    return this.loginService.login().pipe(
      map(result => result?.authToken),
    );
  }

  public override register(): Observable<AuthToken | undefined> {
    return this.loginService.register().pipe(
      map(result => result?.authToken),
    );
  }

  public override refresh(): Observable<AuthToken | undefined> {
    return this.loginService.refresh().pipe(
      map(result => result?.authToken),
    );
  }

  public override logout(): Observable<void> {
    return this.loginService.logout().pipe(
      map(() => undefined),
    );
  }
}
